module.exports = __webpack_public_path__ + "static/media/contactsYellow.3c02f1f1.svg";